import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step12 } from '../../../../../shared/models/component-messages/mapaIN/step12';
import { FormUtilsService } from '../../../../../shared/services/form-utils.service';
import { LogService } from '../../../../../shared/services/log.service';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { CTRL_38 } from '../../../../validators/38/ctrl38';
import { Initial } from '../../models/Initial';
import { MapaINControlNames } from '../../service/mapaINControleNames';

@Component({
  selector: 'app-step12',
  templateUrl: './step12.component.html'
})
export class Step12Component implements OnInit {

  private LOG: LogService = new LogService(Step12Component);

	@Input() initial: Initial;

	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;

	

	@Input() uid = '';

	public rg1 = CTRL_38.id + '_1';


	public step12 = new Step12();

	@Input() linkForRouter: string;

	constructor(
		public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
		private formUtilsService: FormUtilsService
	) { }


  ngOnInit(): void {
	this.parentForm.addControl(this.getStepId() + this.rg1, new FormControl({ rgCtrls: MapaINControlNames.getCtrl_38Names_json() }));
  }

  public getUid() {
		return this.uid;
	}
	
	getStepId() {
		return this.uid.substring(0, this.uid.indexOf("SepSep"));
	}

}
